import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import { CircleEffect } from "../effects/circleEffect";
import type { Player } from "../player";
import { Rock } from "../things/rock";
import { Weapon } from "../weapon";

export class RockGun extends Weapon {
	static key = "RockGun";
	constructor(owner: Player) {
		super(owner, Infinity, true);
	}

	fire(direction: Direction, board: Board): void {
		const delta = directionDelta(direction);
		for (let i = 1; i <= 5; i++) {
			const targetXY = this.owner.xy.add(delta.x * i, delta.y * i);
			if (!board.isInBounds(targetXY)) break;
			if (!board.isPassable(targetXY)) break;
			if (board.hasMob(targetXY)) break;
			board.addThing(new Rock(targetXY));
			board.addEffect(new CircleEffect(targetXY));
		}
	}

	static deserialize(data: any, owner: Player): RockGun {
		const gun = new RockGun(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
